import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {MenuModule} from 'primeng/menu';
import {PMenuFontawesomeDirective} from '@webmate-web-core/shared/directives/p-menu-fontawesome.directive';
import {DragDropDirective} from '@webmate-web-core/shared/directives/dragndrop.directive';
import {PMenuBugFixDirective, PTieredMenuBugFixDirective} from '@webmate-web-core/shared/directives/primeng-menu-bugfix.directive';
import {WmTemplate} from "@webmate-web-core/shared/directives/template.directive";
import {
    POverlayPanelGracefulHoverDirective
} from "../../../workbench/shared/directives/p-overlay-panel-graceful-hover.directive";
import {ClickOutsideDirective} from '@webmate-web-core/shared/directives/clickoutside.directive';

@NgModule({
    declarations: [
        PMenuFontawesomeDirective,
        DragDropDirective,
        PMenuBugFixDirective,
        PTieredMenuBugFixDirective,
        WmTemplate,
        POverlayPanelGracefulHoverDirective
    ],
    imports: [
        CommonModule,
        FormsModule,
        FontAwesomeModule,
        MenuModule,
        ClickOutsideDirective
    ],
    exports: [
        ClickOutsideDirective,
        PMenuFontawesomeDirective,
        DragDropDirective,
        PMenuBugFixDirective,
        PTieredMenuBugFixDirective,
        WmTemplate,
        POverlayPanelGracefulHoverDirective
    ],
})
export class WmDirectivesModule {
}
